import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroupToObject } from '../../pipes/form-group-to-object.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeliveryService } from '../../services/delivery.service';
import { Delivery, DeliveryInvoicePaymentStatus, DeliveryInvoicePaymentStatusAux, DeliveryProduct, DeliveryStatus, DeliveryStatusAux, onlyCurrentMonthIfPartner, TimePeriods } from '../../models/delivery.schema';
import { Product } from '../../models/product.schema';
import { Partner, PartnerPaymentMethods, PartnerPaymentStatus } from '../../models/partner.schema';
import { Expert, ExpertServices } from '../../models/expert.schema';
import { PartnerService } from '../../services/partner.service';
import { ExpertService } from '../../services/expert.service';
import { AuthStatusService } from '../../services/auth-status.service';
import { ProductService } from 'src/app/services/product.service';
import { DeliveryLinkDialogComponent } from '../delivery-link-dialog/delivery-link-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { plainToClass } from 'class-transformer';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/models/user.schema';
import { ServiceModel } from 'src/app/models/service.schems';
import { Service } from 'src/app/services/service.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { PartnerPriorityListService } from 'src/app/services/partner-priority-list.service';
import { PartnerPriorityListSchema } from 'src/app/models/partner-priority-list.schema';
import { AdminValetActivityHelpherService } from 'src/app/helpers/admin-valet-activity-helpher.service';
import { AdminValetActivityService } from 'src/app/services/admin-valet-activity.service';
import { findProvinceFromAddress } from 'src/app/helpers/find-province-from-address.helper';
import { Customer } from 'src/app/models/customer.schema';
import { CustomersService } from 'src/app/services/customers.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { setCustomValidators } from 'src/app/helpers/custom-validator-form-helpers';
import { ShowOtpComponent } from '../show-otp/show-otp.component';
import * as env from '../../../environments/environment';
import { MapHelperService } from 'src/app/helpers/maps-service-helpher.service';
import { APP_CONSTANTS } from 'src/app/constants/constants';

@Component({
  selector: 'app-delivery-form',
  templateUrl: './delivery-form.component.html',
  styleUrls: ['./delivery-form.component.scss']
})
export class DeliveryFormComponent implements OnInit {
  public groups: string[];
  public readonly formValidationMsgs;
  public _deliveryForm: any;
  public delivery: Delivery;
  public deliveryStatus = DeliveryStatus;
  public deliveryStatusAux = DeliveryStatusAux;
  public invoicePaymentStatus = DeliveryInvoicePaymentStatus;
  public invoicePaymentStatusAux = DeliveryInvoicePaymentStatusAux;
  public partners: Partner[];
  public selectedPartner: Partner;
  public loggedInPartner: Partner;
  public experts: Expert[];
  public timePeriods = TimePeriods;
  public products: Product[];
  public initialProducts: Product[];
  public removeFile: boolean;
  public tmpBtnDisabled: boolean;
  public user: User;
  public userDetails: any;
  public services: ServiceModel[];
  public showStartEndTime: boolean = false;
  public showPickUpAddress: boolean = false;
  public showProductValue: boolean = false;
  public showDistanceInput: boolean = false;
  public disableAdditionalPriceInput: boolean = false;
  public selectedService: any;
  previousValues: { startTime: string, endTime: string } = { startTime: '07:00', endTime: '08:00' };
  previousValetTimeValues: { valetStartTime: string, valetEndTime: string } = { valetStartTime: '07:00', valetEndTime: '08:00' };
  selectedProducts: any;
  TotalSelectedProPrice: any;
  selectedPartnerServices: any[] = [];
  pickUpAddressLat: number;
  pickUpAddressLng: number;
  pickUpFTime: any;
  pickUpTTime: any;
  pickUpFTimeError: boolean = false;
  pickUpTTimeError: boolean = false;
  selectedExpert: Expert;
  selectedExpertSalary: any;
  totalDeliveryTime: any = 1;
  selectedExpertServices: any[] = [];
  selectedExpertService: ExpertServices;
  disableValetAdditionalPriceInput: boolean = false;
  selectedValetAddress: string = '';
  valetAddressLat: number;
  valetAddressLng: number;
  totalValetTimeDifference: any = 1;
  showValetStartAndEndTime: boolean = false;
  showProductImage: boolean[] = [];
  productImageUrls: string[] = [];
  isProductPublicPrice: boolean[] = [];
  productPublicPrice: number[] = [];
  corporatePartner: boolean = false;
  partnerPriorityList: PartnerPriorityListSchema[] = [];
  DELUXY_PARTNER: number = 128;
  customers: Customer[] = [];
  customerId: string|number;
  productId: string|number;
  newCustomer: boolean = false;
  selectedVariant: any;
  selectedVariants: any[] = [];
  showProductVariant: boolean[] = [];
  selectedProductsForVariants: any[] = [];
  isDeliveryAndPartnerCitySame: boolean = true;
  public initialPartners: Partner[];
  public initialExperts: Expert[];
  expertIdentityCheck: boolean;
  customerVerification: boolean;
  deliveryId: string;
  isValetIdentityRequired: boolean = false;
  isDeliveryCodeRequired: boolean = false;
  valetIdentity: boolean = false;
  showAddressModal: boolean = false;
  selectedPickupAddress: string | null = null;
  isConfirming = false;
  deliveryCheck = {
    deliveryCodeRequired: false,
    deliveryCode: '',
  };
  showCustomerInformation: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authStatusService: AuthStatusService,
    private _snackBar: MatSnackBar,
    private deliveryService: DeliveryService,
    private partnerService: PartnerService,
    private expertService: ExpertService,
    private service: Service,
    private productService: ProductService,
    public dialog: MatDialog,
    private spinnerService: SpinnerService,
    private partnerPriorityListService: PartnerPriorityListService,
    private adminValetActivityHelpherService: AdminValetActivityHelpherService,
    private adminValetActivityService: AdminValetActivityService,
    private customersService: CustomersService,
    private commanUsesService: CommanUsesService,
    private cdr: ChangeDetectorRef,
    private mapHelperService: MapHelperService,
  ) {
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.formValidationMsgs = Delivery.validationMessages;
  }

  async ngOnInit() {
    try {
      // this.spinnerService.show();
      this.route.queryParams.subscribe((params) => {
        this.customerId = params['customerId'];
      });
      this.route.queryParams.subscribe((params) => {
        this.productId = params['productId'];
      });

      const deliveryId: string = this.route.snapshot.paramMap.get('id');
      if (deliveryId) {
        this.deliveryId = deliveryId;
        try {
          this.delivery = plainToClass(Delivery, await this.deliveryService.getOne(deliveryId));
          if(this.delivery?.serviceType === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL && this.groups.includes('partner')) this.router.navigateByUrl("/404", { skipLocationChange: true });
        }
        catch {
          this.router.navigateByUrl("/404", { skipLocationChange: true });
        }
      }

      await this.initialize();
      this.setDeliveryDateRestriction();
      if(
        this.groups.includes('partner') &&
        this.selectedPartner && 
        (this.selectedPartner?.partnerPaymentMethod && this.selectedPartner?.partnerPaymentStatus === null) ||
        [PartnerPaymentStatus.blocked, PartnerPaymentStatus.inactive].includes(this.selectedPartner?.partnerPaymentStatus)
      ) {
        alert("Lo stato del pagamento è in sospeso. Non è possibile effettuare consegne.");
        this.router.navigateByUrl("/404", { skipLocationChange: true });
        return false;
      }
      setCustomValidators(
        this._deliveryForm.controls.payAtDelivery,
        this._deliveryForm.controls.payAtDeliveryAmount,
        (value) => value === true,
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]
      );
      // this.spinnerService.hide();
    } catch (error) {
      console.log("ERROR", error)
      this.showSnackBar("Something Went Wrong On This Page");
    }
  }

  async initialize() {
    const loggedInUserInfo = await this.authStatusService.getTokenInfo();
    if(this.groups.includes('partner')){
      this.loggedInPartner = await this.partnerService.getOne(loggedInUserInfo['extraId']);
      this.selectedPartner = this.loggedInPartner;
      this.selectedPartnerServices = this.selectedPartner?.partnerServices;

      /* Delivery Security check */
      this.isValetIdentityRequired = this.selectedPartner.checkExpertIndentity;
      this.onValetIdentityChange(this.selectedPartner.checkExpertIndentity);

      this.deliveryCheck.deliveryCodeRequired = this.selectedPartner.deliveryCodeCheck && this.selectedPartner.deliveryCodeCheckType != null;
      this.isDeliveryCodeRequired = this.deliveryCheck.deliveryCodeRequired;
      this.onDeliveryCheckChange();
      /* Delivery Security check */
    }
    this.tmpBtnDisabled = false;
    // this.products = (await this.productService.getAllActiveProducts(undefined, undefined, { 'Product.name': 'ASC' })).products;
    this.products = (await this.productService.getAllActiveProductsForDelivery()).products;
    this.initialProducts = this.products;
    for (let index = 0; index < this.initialProducts.length; index++) {
      if(this.initialProducts[index].id === 23631) {
        console.log("PRODUCT", this.initialProducts[index]);
      }
    }
    if(this.groups.includes('partner') && this.loggedInPartner){
      this.corporatePartner = this.loggedInPartner.partnerServices.some(
        (partnerService) => partnerService.service.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL
      );
      if (!this.corporatePartner) {
        this.products = this.products.filter((product) =>
          product.partner === null || product.partner.id === this.loggedInPartner.id
        );
      }
    }
    if (['admin', 'operation', 'partner'].some(role => this.groups.includes(role))) {
      try {
        [this.partners, this.experts, this.customers] = await Promise.all([
          // this.partnerService.getAllActivePartners(undefined, undefined, { 'Partner.businessName': 'ASC' }).then(res => res.partners),
          this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners),
          // this.expertService.getAllActiveExperts(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' }).then(res => res.experts),
          this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts),
          this.customersService.getAllCustomer(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' }),
        ]);
        this.initialPartners = this.partners;
        this.initialExperts = this.experts;
      } catch {}
    }
    try {
      // this.services = await this.service.getAllServices();
      // this.partnerPriorityList = await this.partnerPriorityListService.getAllPartnerPriorityLists();
    }
    catch { }
    this._deliveryForm = new FormGroup(Delivery.validation());
    if(this.groups.includes('partner')){
      this._deliveryForm.controls.pickUpAddress.setValue(this.loggedInPartner?.address);
    }
    if (this.delivery) {
      try {
        this.expertIdentityCheck = this.delivery.expertIdentityCheck;
        this.customerVerification = this.delivery.deliveryCodeRequired;
        const delivery = this.delivery;
        if(this.delivery.deliveryCodeRequired && this.delivery.deliveryCode && (this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('partner'))) {
          let dialogRef = this.dialog.open(ShowOtpComponent, {
            width: '80vw',
            data: { delivery },
            disableClose: true 
          });
        }
      }
      catch {
        this.router.navigateByUrl("/404", { skipLocationChange: true });
      }
    }
    this.delivery ? this.patch() : (this.delivery = new Delivery());
    if(this.customerId && !this.deliveryId) {
      this.handleCustomerChange(this.customerId);
      this._deliveryForm.controls.customer.controls.id.setValue(Number(this.customerId));
      this._deliveryForm.controls.existingCustomer.setValue(true);
      this.updateValidator(true);
    }
    if(this.productId && !this.deliveryId) {
      let index = 0;
      const deliveryProducts = this._deliveryForm.get('deliveryProducts') as FormArray;
      const productGroup = deliveryProducts.at(index).get('product') as FormGroup;
      let selectedProduct = this.initialProducts.find(p => p.id === Number(this.productId));
      productGroup.get('id')?.setValue(selectedProduct.id || this.productId);
      this.handleProductChange(index, this.productId);
    }
  }

  async delete() {
    if (!confirm("Sei sicuro di voler cancellare questa consegna?"))
      return;
    let delivery: { id: number | string, success: boolean } = await this.deliveryService.delete(this.delivery.id);
    let message = "Cancellazione della consegna fallita.";
    if (delivery.success)
      message = "Cancellazione della consegna avvenuta con successo.";
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    }).afterDismissed().subscribe(result => {
      if (delivery.success)
        this.router.navigate(['/consegne']);
    });
  }

  patch() {
    this.removeFile = false;
    const control = <FormArray>this._deliveryForm.get('deliveryProducts');
    control.clear()
    if (!this.delivery.deliveryProducts || Array.isArray(this.delivery.deliveryProducts) && this.delivery.deliveryProducts.length == 0)
      this.delivery.deliveryProducts = [new DeliveryProduct()];
    this.delivery.deliveryProducts.forEach((f, index) => {
      control.push(this.patchValues(f, index));
    });
    [
      'status', 
      'surname', 
      'name', 
      'address', 
      'intercom', 
      'createdUser', 
      'deliveryDate', 
      'fromTime', 
      'toTime', 
      'notes', 
      'internalNotes',
      'requestExpert', 
      'receiverPhone', 
      'senderSurname', 
      'senderName', 
      'senderPhone', 
      'email', 
      'payAtDelivery', 
      'deluxyDelivery',
      'tryAndReturn', 
      'longitude', 
      'latitude', 
      'pickUpTime', 
      'smsPhoneNo', 
      'ddtNumber', 
      'price', 
      'startTime', 
      'endTime', 
      'service', 
      'productValue',
      'pickUpAddress', 
      'additionalPrice', 
      'distance', 
      'isFlexblePickUpTime', 
      'serviceName', 
      'billable', 
      'expertSalary', 
      'expertServiceId', 
      'payable',
      'valetAdditionalPrice', 
      'valetStartTime', 
      'valetEndTime', 
      'deliveryRuleId', 
      'existingCustomer', 
      'province', 
      'saleId', 
      'orderId', 
      'realOrderNumber', 
      'payAtDeliveryAmount', 
      'isFlexiblePrice',
      'invoicePaymentStatus',
      'personalizeSaleNotes',
      // 'deliveryWithoutCommision',
    ].forEach(param => {
        if (this.delivery[param] instanceof Date)
          this._deliveryForm.controls[param].setValue(new DatePipe('it-IT').transform(this.delivery[param], 'yyyy-MM-dd'));
        else
          this._deliveryForm.controls[param].setValue(this.delivery[param]);
        if(param === 'startTime'){
          this._deliveryForm.controls.startTime.setValue(this.delivery[param]?.slice(0, -3));
        }
        if(param === 'endTime'){
          this._deliveryForm.controls.endTime.setValue(this.delivery[param]?.slice(0, -3));
        }
        if(param === 'valetStartTime'){
          this._deliveryForm.controls.valetStartTime.setValue(this.delivery[param]?.slice(0, -3));
        }
        if(param === 'valetEndTime'){
          this._deliveryForm.controls.valetEndTime.setValue(this.delivery[param]?.slice(0, -3));
        }
        if(this.delivery?.isFlexblePickUpTime){
          this.patchPickUpFlexbleTime();
        }
        if(this.groups.includes('partner')){
          this._deliveryForm.controls.pickUpAddress.setValue(this.loggedInPartner?.address);
        }
      });
    if (this.delivery.partner){
      this._deliveryForm.controls.partner.controls.id.setValue(this.delivery.partner.id);
      this.selectedPartner = this.partners.find((partner) => {
        return partner.id == this.delivery.partner.id;
      });
    }

    if (this.delivery.customer && this.delivery.existingCustomer){
      this._deliveryForm.controls.customer.controls.id.setValue(this.delivery.customer.id);
      this._deliveryForm.controls.existingCustomer.setValue(true);
      // this._deliveryForm.get('existingCustomer')?.disable();
      this.updateValidator(this.delivery.existingCustomer);
    }

    if (this.delivery.expert){
      this._deliveryForm.controls.expert.controls.id.setValue(this.delivery.expert.id);
      this.selectedExpert = this.experts.find((expert) => {
        return expert.id == this.delivery.expert.id;
      });
    }

    this.patchPartnerService();
    this.patchExpertService();
    if (this.delivery.expert)
      this._deliveryForm.controls.expert.controls.id.setValue(this.delivery.expert.id);

    if(this.delivery.province) {
      this.filterPartnersAndExpertsByProvince(this.delivery.province);
    }
    /*
    if(this.selectedPartner) {
      this.filterProducts();
    }
    */
    if(this.delivery.pickUpAddress) {
      this._deliveryForm.controls.pickUpAddress.setValue(this.delivery.pickUpAddress);
    }
    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) {
      this.managePriceForCorporateService();
    }

  }

  patchValues(deliveryProduct: DeliveryProduct, index: number) {
    let productForm = Delivery.productFormGroup();
    this.showProductImage[index] = deliveryProduct?.product?.image ? true : false;
    this.productImageUrls[index] = deliveryProduct?.product?.image ? deliveryProduct?.product?.image : '';
    let selectedProduct = this.products.find(product => product?.id == deliveryProduct?.product?.id);
    if(deliveryProduct?.productVariant || selectedProduct?.productVariants.length > 0) {
      this.showProductVariant[index] = true;
      this.selectedProductsForVariants[index] = selectedProduct;
      this.selectedVariants[index] = selectedProduct?.productVariants.find((item) => item.id === deliveryProduct?.productVariant?.id);
      productForm.controls.productVariant.setValue(deliveryProduct?.productVariant?.id);
    }

    let additionalInfo = this.delivery?.flexiblePrice && typeof this.delivery?.flexiblePrice === 'string' ? JSON.parse(this.delivery?.flexiblePrice) : [];
    additionalInfo = additionalInfo[index];
    if (deliveryProduct?.product?.id){
        productForm.controls.product.setValue(
          { 
            id: deliveryProduct.product.id,
            quantity: deliveryProduct.quantity,
            flexiblePrice: additionalInfo ? additionalInfo?.product?.flexiblePrice || (deliveryProduct?.productVariant ? deliveryProduct?.productVariant?.variantPrice : deliveryProduct?.product?.price) : 0,
            deliveryWithoutCommision: deliveryProduct.deliveryWithoutCommision
          }
        );
    }

    return productForm;
  }

  /** Show PRODOTTO Value for sales (% fee) and corporate (Shopify listino total). */
  private syncShowProductValueVisibility(): void {
    const fromService = this.selectedService?.service?.pricingModel?.toLowerCase();
    const fromForm = String(this._deliveryForm?.controls?.serviceType?.value || '').toLowerCase();
    const m = fromService || fromForm;
    this.showProductValue =
      m === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL ||
      m === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
  }

  patchPartnerService(){
    if(this.delivery?.service && this.selectedPartner){    // Newly Delivery
      this.partnerChange(this.selectedPartner?.id);
      this.selectedService = this.selectedPartnerServices.find((item) => {
        return item?.service?.id == this.delivery?.service;
      });

      this.setHideCustomerInfoForDelivery(this.delivery?.service);

      this.showStartEndTime = this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL;
      if(this.showStartEndTime){
        this._deliveryForm.controls.fromTime.setValue(this.delivery?.startTime);
        this._deliveryForm.controls.toTime.setValue(this.delivery?.endTime);
      }
      this.syncShowProductValueVisibility();
      // this.showPickUpAddress = this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL;
      // this.showDistanceInput = this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL;
      const isFixedPriceAdminOrOperation =
        (this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) &&
        (this.groups.includes('admin') || this.groups.includes('operation'));

      const isCorporatePartner =
        (this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) &&
        this.groups.includes('partner');

      this.showPickUpAddress = isFixedPriceAdminOrOperation || isCorporatePartner;
      this.showDistanceInput = isFixedPriceAdminOrOperation || isCorporatePartner;
      this._deliveryForm.controls.serviceType.setValue(this.selectedService?.service?.pricingModel.toLowerCase());
    } else {   // Old Delivery
      this.partnerChange(this.selectedPartner?.id);
      this.setHideCustomerInfoForDelivery();
    }
  }

  patchExpertService(){
    if(this.delivery?.expertServiceId && this.selectedExpert){
      this.selectedExpert = this.experts.find((expert) => expert?.id == this.delivery.expert.id);
      this.selectedExpertServices = this.selectedExpert?.expertServices;
      this.selectedExpertService = this.selectedExpertServices.find((expertService => expertService?.id == this.delivery.expertServiceId));
      this._deliveryForm.controls.expertServiceId.setValue(this.selectedExpertService.id);
      if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'hourlyratesalary'){
        this.showValetStartAndEndTime = true;
      }
    }
    if(this.selectedExpert){
      this.selectedExpert = this.experts.find((expert) => expert?.id == this.delivery.expert.id);
      this.selectedExpertServices = this.selectedExpert?.expertServices;
    }

    /*
    if(this.selectedExpert && this.delivery?.pickUpAddress && this.delivery?.address && this.delivery?.latitude && this.delivery?.longitude && this.selectedExpertService?.service?.serviceType?.toLowerCase() != 'hourlyratesalary'){
      this.calculateFixedPriceValetSalary();
    }
    */
  }

  addProduct() {
    const control = <FormArray>this._deliveryForm.get('deliveryProducts');
    control.push(Delivery.productFormGroup());
  }

  removeProduct(index: number) {
    const control = <FormArray>this._deliveryForm.get('deliveryProducts');
    if (control.length === 1) {
      return;
    }
    // this.showProductImage[index] = false;
    // this.productImageUrls[index] = '';
    control.removeAt(index);
    this.selectedProductsForVariants.splice(index, 1);
    this.selectedVariants.splice(index, 1);
    this.showProductVariant.splice(index, 1);
    this.showProductImage.splice(index, 1);
    this.productImageUrls.splice(index, 1);
    this.setProductValue();
  }

  async onSubmit(e:any=[]) {
    if(this._deliveryForm.valid) {
      this.tmpBtnDisabled = true;
      let delivery: Delivery = (new FormGroupToObject()).transform(this._deliveryForm);
      let selectedPartner: Partner = this.initialPartners.find(p => p.id == delivery.partner.id) || this.loggedInPartner;
      let partner: Partner;

      delivery.expertIdentityCheck = this.valetIdentity;
      delivery.deliveryCodeRequired = this.deliveryCheck.deliveryCodeRequired;

      if(
        delivery?.partner?.id 
        && this.selectedPartner?.partnerPaymentMethod === 'creditCard' && 
        this.selectedPartner?.partnerPaymentStatus === PartnerPaymentStatus.active
      ) {
        partner = await this.partnerService.getOne(delivery?.partner?.id);
      }
  
      if(
        !this.delivery.id &&
        delivery?.payable && 
        delivery?.serviceType?.toLowerCase() != APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL &&
        partner?.partnerPaymentMethod === 'creditCard' &&
        partner?.partnerPaymentStatus === PartnerPaymentStatus.active &&
        partner?.stripeCustomer && 
        partner?.stripeCustomer?.stripeCustomerCards?.length
      ) {
        if(!confirm(`Questa consegna attiverà un addebito immediato e l'importo verrà detratto dalla carta di credito. Vuoi procedere?`)) {
          this.tmpBtnDisabled = false;
          return;
        }
      }

      if (!delivery?.pickUpAddress || delivery.pickUpAddress.trim() === '') {
        this.commanUsesService.showSnackBar(`Assicurati che l'indirizzo di ritiro non sia vuoto.`);
        return;
      }
      delivery.flexiblePrice =  JSON.stringify(delivery?.deliveryProducts);
      let userDetails = JSON.parse(sessionStorage.getItem("currentUser"));
      let sendSmsConfirmation: boolean = false;
      if(!this.route.snapshot.paramMap.get('id')){
        if((this.groups.includes('partner')) || (this.groups.includes('admin')) || (this.groups.includes('operation'))){
          if((userDetails?.partner?.sendSms && delivery.smsPhoneNo) || ((this.groups.includes('admin') || this.groups.includes('operation')) && delivery.smsPhoneNo && delivery.deluxyDelivery)){
            if (confirm("Vuoi inviare sms?")){
              sendSmsConfirmation = true;
            } else {
              this.tmpBtnDisabled = false;
            }
          }
        }
      }

      let ddtFile = delivery.ddtFile;
      if (!this.removeFile) delete delivery.ddtFile;
      for (let i = delivery.deliveryProducts.length - 1; i >= 0; i--) {
        if (!delivery.deliveryProducts[i].product.id)
          delivery.deliveryProducts.splice(i, 1);
      }
      let promiseResult: any;
      let createType: boolean = true;
      let createOrUpdateActivities: boolean = false;
      // console.log('delivery', delivery); return

      if(!this._deliveryForm.get('customer').get('id').value && !this.newCustomer){
        delivery.customer = null;
      }

      if(this.newCustomer){
        if(!this._deliveryForm.get('existingCustomer').value) {
          let email = this._deliveryForm.get('email').value ?
                      this._deliveryForm.get('email').value :
                      `${Date.now() + Math.floor(Math.random() * 100)}${this._deliveryForm.get('name').value.toLowerCase().replace(/\W/g, '')}${this._deliveryForm.get('surname').value.toLowerCase().replace(/\W/g, '')}@gmail.com`;
    
          let newCostomer: Customer = {
            address     :this._deliveryForm.get('address').value || '',
            latitude    :this._deliveryForm.get('latitude').value || '',
            longitude   :this._deliveryForm.get('longitude').value || '',
            dob         :new Date(),
            intercom    :this._deliveryForm.get('intercom').value || '',
            notes       :'',
            phone       :this._deliveryForm.get('receiverPhone').value || '',
            user        :{
              surname   :this._deliveryForm.get('surname').value || '',
              name      :this._deliveryForm.get('name').value || '',
              email     :email
            }
          };
          let customer = await this.customersService.create(newCostomer);
          if(customer){
            delivery.customer.id = customer.id;
            delivery.existingCustomer = true;
          }
        }
      }
      if (this.delivery['id']) {
        promiseResult = this.deliveryService.update(this.delivery['id'], delivery);
        createType = false;
      }
      else{
        promiseResult = this.deliveryService.create(delivery, sendSmsConfirmation);
      }

      promiseResult.then(async (data: Delivery) => {
        if((this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('partner')) && this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.delivery['id'] === undefined){
          await this.createNewSaleDelivery(data);
        }

        if(data.status === DeliveryStatus.canceled){
          await this.removeValetActivities(data);
        }

        await this.adminValetActivityHelpherService.createOrUpdateActivitiesNewFunction(data);
        await this.adminValetActivityHelpherService.checkForExpertDeliveryRule(data);
        
        let allGood = true;
        this.delivery = plainToClass(Delivery, data);
        if (ddtFile)
          this.delivery = await this.uploadDdt(this.delivery.id).catch((err) => {
            this.errorMessage(createType, err);
            allGood = false;
          });
        if (allGood) {
          const message: string = `Consegna ${createType ? "creata" : "aggiornata"} con successo. ${createType ? "Nuovo id creato : " + this.delivery.id : ""}`;
          this._snackBar.open(message, 'Chiudi', {
            direction: "ltr",
            duration: 2000,
            horizontalPosition: "center",
            politeness: "assertive",
            verticalPosition: "top"
          }).afterDismissed().subscribe(result => {
            if (createType)
              this.router.navigate(['/consegne', this.delivery.id, 'edit']);
          });
          this.initialize();
          this.tmpBtnDisabled = false;
        }
      }).catch(error => {
        this.errorMessage(createType, error);
        this.tmpBtnDisabled = false;
      });
    } else {
      this.commanUsesService.showSnackBar('Form is not valid');
    }
  }

  async createNewSaleDelivery(inDelivery: Delivery){
    try {
      this.partnerPriorityList = await this.partnerPriorityListService.getAllPartnerPriorityLists();
      let selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;
      const selectedProduct: Product = this.initialProducts.find(p => p.id === selectedProducts[0].product.id);
      console.log("selectedProduct", selectedProduct);

      this.TotalSelectedProPrice = selectedProducts?.reduce((acc, item) => {
        const product = this.initialProducts.find(p => p.id === item.product.id);
        const price = Number(product?.price) * Number(item.product.quantity || 0);
        if (isNaN(price)) {
          this.showSnackBar('Cannot calculate price for product');
          return acc;
        }
        return acc + price;
      }, 0);

      const province = this.findProviceFromAddress(this._deliveryForm.controls.address?.value);
      console.log("province", province)
      const isProvinceMatched: boolean = selectedProduct.partner.partnerProvinces?.some((partnerProvince) => {
        return province?.toLowerCase() === partnerProvince?.province?.provinceCode?.toLowerCase() || province?.toLowerCase() === partnerProvince?.province?.province?.toLowerCase();
      });
      console.log("isProvinceMatched", isProvinceMatched)

      const selectPartner = () => {
        if(selectedProduct.uniqueProduct){
          return isProvinceMatched ? this.initialPartners.find(p => p.id === selectedProduct.partner.id) : this.initialPartners.find(p => p.id === this.DELUXY_PARTNER);
        } else {
          const priorityList = this.partnerPriorityList.find(pl =>
            selectedProduct.productCategory.categoryName.toLowerCase() === pl.productCategory.categoryName.toLowerCase() &&
            province?.toLowerCase() === pl.province.provinceCode.toLowerCase() || province?.toLowerCase() === pl?.province?.province?.toLowerCase()
          );
          return priorityList ? priorityList.partnerPriorities[0].partner : this.initialPartners.find(p => p.id === this.DELUXY_PARTNER);
        }
      }

      const selectedPartner = selectPartner();
      console.log("selectedPartner", selectedPartner);
      const partnerSalesService = selectedPartner.partnerServices.find(p =>
        p.service.pricingModel.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL
      );

      console.log("partnerSalesService", partnerSalesService)

      if (!partnerSalesService) {
        alert(`Partner ${selectedPartner.businessName} has no Sales Type Services. Cannot create corresponding Sales Service type delivery`);
        return;
      }

      this.patchDeliveryForSaleDelivery(selectedPartner, partnerSalesService);
      const delivery = JSON.parse(JSON.stringify((new FormGroupToObject()).transform(this._deliveryForm)));
      if(!delivery?.customer?.id) delete delivery?.customer;
      delivery.correspondDelivery = inDelivery.id;
      // this.deliveryService.create(delivery, false);
      this.deliveryService.createAdditionalSaleDelivery(delivery, false);
    } catch (error) {
      // console.log(error);
      this._snackBar.open(`Something went wrong`,
        'Chiudi',
        {
          direction: 'ltr',
          duration: 2000,
          horizontalPosition: 'center',
          politeness: 'assertive',
          verticalPosition: 'top',
        }
      );
    }
  }

  findProviceFromAddress(address: string){
    const addressParts = address.split(', ');
    const province = addressParts[addressParts.length - 2].split(' ').pop();
    return province;
  }

  patchDeliveryForSaleDelivery(selectedPartner: Partner, partnerSalesService){
    const { startTime, endTime } = this.previousValues;
    this._deliveryForm.patchValue({
      partner: {
        id: selectedPartner.id,
      },
      pickUpAddress: selectedPartner.address,
      startTime,
      endTime,
      distance: null,
      hours: 0,
      valetStartTime: null,
      valetEndTime: null,
      service: String(partnerSalesService.service.id),
      serviceName: partnerSalesService?.service?.serviceName,
      serviceType: partnerSalesService?.service?.pricingModel,
      deluxyDelivery: true,
      price: this.TotalSelectedProPrice ? (Number(partnerSalesService.price) * this.TotalSelectedProPrice) / 100 : 0,
      productValue: this.TotalSelectedProPrice || 0
    });
  }

  errorMessage(createType, error) {
    this._snackBar.open(`Errore ${createType ? 'nella creazione' : "nell'aggiornamento"} della consegna`,
      'Chiudi',
      {
        direction: 'ltr',
        duration: 2000,
        horizontalPosition: 'center',
        politeness: 'assertive',
        verticalPosition: 'top',
      }
    );
    // console.log(error);
  }

  setTime(timePeriod) {

    if (this.timePeriods[timePeriod]) {
      this._deliveryForm.controls.fromTime.setValue(this.timePeriods[timePeriod]['from']);
      this._deliveryForm.controls.toTime.setValue(this.timePeriods[timePeriod]['to']);
    }
    else {
      this._deliveryForm.controls.fromTime.setValue('');
      this._deliveryForm.controls.toTime.setValue('');
    }
  }

  setDeliveryStatus(idExpert){
    this._deliveryForm.controls.status.setValue(this.deliveryStatus.assigned);
    this.selectedExpert = this.experts.find((expert) => expert?.id == idExpert);
    this.selectedExpertServices = this.selectedExpert?.expertServices;
    this.expertServiceAndSalary();
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this._deliveryForm.get('ddtFile').setValue(file);
    }
  }

  uploadDdt(deliveryId: number) {
    return this.deliveryService.updateDeliveryDdt(
      deliveryId,
      this._deliveryForm.get('ddtFile').value
    );
  }

  /*
  async showDdt() {
    let res = await this.deliveryService.findOneDeliveryDdt(this.delivery.id);
    let anchor = document.createElement('a');
    anchor.download = this.delivery.ddtFile.replace(/-.{4}(\..{3,4})$/, '$1');
    anchor.href = (window.webkitURL || window.URL).createObjectURL(res.body);
    anchor.dataset.downloadurl = [res.body.type, anchor.download, anchor.href].join(':');
    anchor.click();
  }
  */

  async showDdt(delivery: Delivery) {
    if (!delivery?.ddtFile) return;

    const encodedFileName = encodeURIComponent(delivery.ddtFile);
    const fileUrl = `${env.environment.url}/assets/delivery/ddt/${encodedFileName}`;

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = delivery.ddtFile;

      document.body.appendChild(anchor);
      anchor.click();

      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);

    } catch (err) {
      this.commanUsesService.showSnackBar('Errore download file');
    }
  }

  deleteFile() {
    this.removeFile = true;
  }

  async showLink(event: Event) {
    event.preventDefault();
    if (!this.delivery.identifier)
      this.delivery = await this.deliveryService.generateIdentifier(this.delivery.id);
    this.dialog.open(DeliveryLinkDialogComponent, { width: '80vw', data: { delivery: this.delivery } });
  }

  async getAddress(place: any) {
    // console.log("place", place)
    if (!this._deliveryForm) return;
    this._deliveryForm.controls.partner.controls.id.setValue(null);
    this._deliveryForm.controls.address.touched = true;
    this._deliveryForm.controls.address.setValue(place.formatted_address || place.name || '');
    this._deliveryForm.controls.latitude.setValue(place.geometry?.location?.lat() || '');
    this._deliveryForm.controls.longitude.setValue(place.geometry?.location?.lng() || '');
    let province: string = findProvinceFromAddress(place);
    console.log("province", province);
    if(!province) {
      alert("Province is not found with filled address, Please enter the address again.");
      return false;
    }

    /* Filter partners and experts according to delivery address province */
    this.filterPartnersAndExpertsByProvince(province);
    /* Filter partners and experts according to delivery address province */

    this._deliveryForm.controls.province.setValue(province);

    let pickUpAddress: string;

    if(this._deliveryForm.controls.pickUpAddress.value != '' || this._deliveryForm.controls.pickUpAddress.value != null) {
      pickUpAddress = this._deliveryForm.controls.pickUpAddress.value;
    } else {
      if (this.groups.includes('partner') && this.loggedInPartner) {
        pickUpAddress = this.loggedInPartner?.address;
      } else if(this.selectedPartner){
        pickUpAddress = this.selectedPartner?.address;
      }
    }
    this._deliveryForm.controls.pickUpAddress.setValue(pickUpAddress);

    this.isDeliveryAndPartnerCitySame = await this.commanUsesService.checkDeliveryAndPartnerAddressCity((place.formatted_address || place.name), pickUpAddress);
    await this.geocodePickupAddress(pickUpAddress);

    if(((this.selectedService?.service?.pricingModel == APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL) || this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) || (this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner'))){
      this.handleDistanceChange(Number(this._deliveryForm.controls.distance.value));
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary'){
      await this.calculateFixedPriceValetSalary();
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'hourlyratesalary'){
      await this.calculateTimeDifference();
    }
    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL) {
      this.setProductValue();
    }

    /* For Ware-House service */
    if(this.selectedService?.service?.pricingModel == APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) {
      this.handleWareServiceInvoicePrice();
    }

    /* For Ware-House salary */
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_SALARY_MODEL){
      this.handleWareServiceSalaryPrice();
    }

    //changed  here
    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) {
      this.managePriceForCorporateService();
    }
  }
  //till here

  filterPartnersAndExpertsByProvince(province: string){

    this.partners = this.initialPartners.filter((partner) =>
      partner.partnerProvinces.some((partnerProvince) =>
        partnerProvince?.province?.provinceCode?.toLowerCase() === province?.toLowerCase()
      )
    );

    this.experts = this.initialExperts.filter((partner) =>
      partner.expertProvinces.some((partnerProvince) =>
        partnerProvince?.province?.provinceCode?.toLowerCase() === province?.toLowerCase()
      )
    );

    if (!this.delivery?.id) return;
    const { partner, expert } = this.delivery;

    if (partner?.id) {
      const matchedPartner = this.partners.find(p => p.id === partner.id);
      this._deliveryForm.controls.partner.controls.id.setValue(matchedPartner?.id || null);
    }

    if (expert?.id) {
      const matchedExpert = this.experts.find(e => e.id === expert.id);
      this._deliveryForm.controls.expert.controls.id.setValue(matchedExpert?.id || null);
    }

  }

  async geocodePickupAddress(pickUpAddress: string) {
    try {
      const geocoder = new google.maps.Geocoder();
      const results = await new Promise<any>((resolve, reject) => {
        geocoder.geocode({ 'address': pickUpAddress }, (results, status) => {
          if (status === 'OK') {
            resolve(results);
          } else {
            reject(status);
          }
        });
      });

      if (results && results.length > 0) {
        this.pickUpAddressLat = results[0].geometry?.location?.lat() || '';
        this.pickUpAddressLng = results[0].geometry?.location?.lng() || '';
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        if (this._deliveryForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        const fixedAddressLatLng = new google.maps.LatLng(this.pickUpAddressLat, this.pickUpAddressLng);
        const selectedAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
        const distanceMatrixService = new google.maps.DistanceMatrixService();
        if (this.pickUpAddressLat && this.pickUpAddressLng && deliveryAddLat && deliveryAddLng) {
          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [fixedAddressLatLng],
              destinations: [selectedAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          // console.log('getAddressdistanceInKm', distanceInKm)
          this._deliveryForm.controls.distance.setValue(distanceInKm?.toFixed(2));
          // this.handleDistanceChange(distanceInKm);
        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
          return;
        }
      } else {
        alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
        return;
      }
    } catch (error) {
      // console.log('Error', error);
      alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
      return;
    }
  }

  directions(event: Event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this._deliveryForm.controls.address.value}`, '_blank');
  }

  handleServiceChange(event: any){

    this.selectedService = this.selectedPartnerServices.find((item) => {
      return item?.service?.id == event;
    });

    this.setHideCustomerInfoForDelivery(event);

    this._deliveryForm.controls.serviceType.setValue(this.selectedService?.service?.pricingModel);
    this._deliveryForm.controls.serviceName.setValue(this.selectedService?.service?.serviceName);

    this._deliveryForm.controls.startTime.setValue(this.previousValues.startTime);
    let pickUpAddress: string = '';
    this._deliveryForm.controls.endTime.setValue(this.previousValues.endTime);
    if(this._deliveryForm.controls.pickUpAddress.value != '' || this._deliveryForm.controls.pickUpAddress.value != null) {
      pickUpAddress = this._deliveryForm.controls.pickUpAddress.value;
    } else {
      if (this.groups.includes('partner') && this.loggedInPartner) {
        pickUpAddress = this.loggedInPartner?.address;
      } else {
        pickUpAddress = (this.selectedPartner ? this.selectedPartner?.address : '');
      }
    }

    if(
      (this.selectedService?.service?.pricingModel === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) 
      || 
      (this.selectedService?.service?.pricingModel === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner')) 
    ){
      this._deliveryForm.controls.pickUpAddress.setValue(pickUpAddress);
      this._deliveryForm.controls.price.setValue(this.selectedService?.price);
      this.handleDistanceChange(Number(this._deliveryForm.controls.distance.value));
      this._deliveryForm.controls.startTime.setValue(null);
      this._deliveryForm.controls.endTime.setValue(null);
      // this._deliveryForm.controls.productValue.setValue(null);
      // this._deliveryForm.controls.distance.setValue(null);
      this._deliveryForm.controls.hours.setValue(0);
      this._deliveryForm.controls.valetStartTime.setValue(null);
      this._deliveryForm.controls.valetEndTime.setValue(null);
      if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) {
        this.managePriceForCorporateService();
      }
    }

    if(this.selectedService?.service?.pricingModel === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL){
      // this._deliveryForm.controls.distance.setValue(null);
      this._deliveryForm.controls.startTime.setValue(this.previousValues.startTime);
      this._deliveryForm.controls.endTime.setValue(this.previousValues.endTime);
      this._deliveryForm.controls.fromTime.setValue(this.previousValues.startTime);
      this._deliveryForm.controls.toTime.setValue(this.previousValues.endTime);
      this._deliveryForm.controls.price.setValue(this.selectedService?.price);
      this._deliveryForm.controls.productValue.setValue(null);
      this._deliveryForm.controls.pickUpAddress.setValue(pickUpAddress);
      this.totalValetTimeDifference = 1;
      this._deliveryForm.controls.valetStartTime.setValue(this.previousValues.startTime);
      this._deliveryForm.controls.valetEndTime.setValue(this.previousValues.endTime);
      this.previousValetTimeValues.valetStartTime = this._deliveryForm.value.startTime;
      this.previousValetTimeValues.valetEndTime = this._deliveryForm.value.endTime;
    }

    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL){
      this._deliveryForm.controls.pickUpAddress.setValue(pickUpAddress);
      this._deliveryForm.controls.startTime.setValue(null);
      // this._deliveryForm.controls.distance.setValue(null);
      this._deliveryForm.controls.endTime.setValue(null);
      this._deliveryForm.controls.hours.setValue(0);
      this.setProductValue();
      this._deliveryForm.controls.valetStartTime.setValue(null);
      this._deliveryForm.controls.valetEndTime.setValue(null);
    }
    let flexbleDelivery: boolean = ((this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) || (this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner')));
    let deluxyDelivery: boolean = this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
    this._deliveryForm.controls.requestExpert.setValue(flexbleDelivery);
    this._deliveryForm.controls.deluxyDelivery.setValue(deluxyDelivery);
    this.showStartEndTime = this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL;
    this.syncShowProductValueVisibility();
    this.showPickUpAddress = ((this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) || (this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner')));
    this.showDistanceInput = ((this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) || (this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner')));
    this.expertServiceAndSalary();
  }

  reset(){
    this._deliveryForm.controls.pickUpAddress.setValue(null);
    this._deliveryForm.controls.startTime.setValue(null);
    // this._deliveryForm.controls.distance.setValue(null);
    this._deliveryForm.controls.endTime.setValue(null);
    this._deliveryForm.controls.price?.setValue(null);
    this._deliveryForm.controls.productValue?.setValue(null);
    this._deliveryForm.controls.service?.setValue(null);
    this._deliveryForm.controls.hours.setValue(0);
    this._deliveryForm.controls.requestExpert.setValue(false);
    this._deliveryForm.controls.deluxyDelivery.setValue(false);
    this.showStartEndTime = false;
    this.showProductValue = false;
    this.showPickUpAddress= false;
    this.showDistanceInput= false;
  }

  handleStartTimeChange(value: string) {
    this._deliveryForm.controls.startTime.setValue(value);
    const startTime = new Date('1970-01-01T' + this._deliveryForm.value?.startTime + ':00');
    const endTime = new Date(startTime.getTime() + 3600000);
    const endTimeString = this.formatTime(endTime);
    this._deliveryForm.controls.endTime.setValue(endTimeString);
    this._deliveryForm.controls.fromTime.setValue(value);
    this._deliveryForm.controls.toTime.setValue(endTimeString);
    this.calculateTimeDifference();
  }

  formatTime(date: Date): string {
    return date.toTimeString().slice(0, 5); // Format as HH:MM
  }


  handleEndTimeChange(value: string) {
    this._deliveryForm.controls.endTime.setValue(value);
    this._deliveryForm.controls.toTime.setValue(value);
    this.calculateTimeDifference();
  }

  calculateTimeDifference() {
    const startTime = new Date('1970-01-01T' + this._deliveryForm.value?.startTime + ':00');
    const endTime = new Date('1970-01-01T' + this._deliveryForm.value?.endTime + ':00');
    const timeDiff = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(timeDiff / 3600000);
    if(hours <= 0){
      alert('Minimum one hour is required');
      this._deliveryForm.controls.startTime.setValue(this.previousValues.startTime);
      this._deliveryForm.controls.endTime.setValue(this.previousValues.endTime);
      this._deliveryForm.controls.fromTime.setValue(this.previousValues.startTime);
      this._deliveryForm.controls.toTime.setValue(this.previousValues.endTime);
      this._deliveryForm.controls.valetStartTime.setValue(this.previousValues.startTime);
      this._deliveryForm.controls.valetEndTime.setValue(this.previousValues.endTime);
      return false;
    }
    const minutes = Math.floor((timeDiff % 3600000) / 60000);
    // let totalTime = `${hours}.${minutes}`;
    const totalTime = hours + minutes / 60;
    this.totalDeliveryTime = totalTime.toFixed(2);
    this.totalValetTimeDifference = totalTime.toFixed(2);
    // console.log('this.totalDeliveryTime', this.totalDeliveryTime)
    let price = hours !== 0 ? Number(this.selectedService?.price) * Number(this.totalDeliveryTime) : Number(this.selectedService?.price);

    // console.log("PARTNER HOURLY PRICE NORMAL PRICE", price);
    /*
    if(!this.isDeliveryAndPartnerCitySame) {
      const kmPrice = this.selectedPartner?.extraOutSideCityKmPrice || 0;
      const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;
      const extraOutsideCityValue = kmPrice * distance;
      price = extraOutsideCityValue;
      // console.log("PARTNER EXTRA OUTSIDE CITY HOURLY PRICE", price);
    }
    */
    this._deliveryForm.controls.price.setValue(price?.toFixed(2));
    this._deliveryForm.controls.hours.setValue(this.totalDeliveryTime);
    this.previousValues.startTime = this._deliveryForm.value.startTime;
    this.previousValues.endTime = this._deliveryForm.value.endTime;
    this.previousValetTimeValues.valetStartTime = this._deliveryForm.value.startTime;
    this.previousValetTimeValues.valetEndTime = this._deliveryForm.value.endTime;
    this.expertServiceAndSalary();
  }

  partnerChange(partnerId: any){
    if(this.partners){
      this.selectedPartner = this.partners.find((partner) => {
        return partner.id == partnerId;
      });
    }
    if(this.groups.includes('admin') || this.groups.includes('operation')){
      this.selectedPartnerServices = this.selectedPartner?.partnerServices;
    }
    let pickUpAddress = (this.selectedPartner ? this.selectedPartner?.address : '');
    if(!this.delivery['id']){
      this._deliveryForm.controls.pickUpAddress.setValue(pickUpAddress);
    }
    if (this.selectedPartnerServices) {
      this.selectedService = this.selectedPartnerServices.map(service => {
          return { label: service.name, value: service.id };
        });
    }
  }

  async handlePartnerChangeDropDown(partnerId: any){
    this._deliveryForm.controls.service.setValue(null);
    this.reset();
    if(this.partners){
      this.selectedPartner = this.partners.find((partner) => {
        return partner.id == partnerId;
      });
    }

    this.isValetIdentityRequired = this.selectedPartner.checkExpertIndentity;
    this.onValetIdentityChange(this.selectedPartner.checkExpertIndentity);

    this.deliveryCheck.deliveryCodeRequired = this.selectedPartner.deliveryCodeCheck && this.selectedPartner.deliveryCodeCheckType != null;
    this.isDeliveryCodeRequired = this.deliveryCheck.deliveryCodeRequired;
    this.onDeliveryCheckChange();
    /* Filter products according to selected, deluxy and no partner */
    // this.filterProducts();
    /* Filter products according to selected, deluxy and no partner */

    this.selectedPartnerServices = this.selectedPartner?.partnerServices;
    let pickUpAddress = (this.selectedPartner ? this.selectedPartner?.address : '');
    this._deliveryForm.controls.pickUpAddress.setValue(pickUpAddress);
    if (this.selectedPartnerServices) {
      this.selectedService = this.selectedPartnerServices.map(service => {
        return { label: service.name, value: service.id };
      });
    }
    this.isDeliveryAndPartnerCitySame = await this.commanUsesService.checkDeliveryAndPartnerAddressCity(this._deliveryForm.controls.address.value, pickUpAddress);
    await this.geocodePickupAddress(pickUpAddress);
    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) {
      this.managePriceForCorporateService();
    }
  }

   // Use pipe sortProducts instead of this
  filterProducts() { 
    const selectedPartnerId = Number(this.selectedPartner?.id);
    this.products = this.initialProducts
      .filter((product) => {
        const partnerId = product?.partner?.id;
        return (
          Number(partnerId) === selectedPartnerId ||
          Number(partnerId) === 128 ||
          partnerId == null ||
          partnerId != null
        );
      })
      .sort((a, b) => {
        const getPriority = (product: any): number => {
          const partnerId = Number(product?.partner?.id);
          if (partnerId === selectedPartnerId) return 0; // highest priority
          if (partnerId === 128) return 1;               // middle
          return 2;                                      // lowest
        };
        return getPriority(a) - getPriority(b);
      });
  }

  produtsSortByLetters() {
    // Sort products alphabetically, while keeping partner products at the top and in bold
    this.products = this.products.sort((a, b) => {
      // Skip sorting for partner products, as they should stay at the top
      if (a?.partner?.id === Number(this.selectedPartner?.id) && b?.partner?.id !== Number(this.selectedPartner?.id)) return -1;
      if (b?.partner?.id === Number(this.selectedPartner?.id) && a?.partner?.id !== Number(this.selectedPartner?.id)) return 1;

      // Compare products based on their first letter (ignoring non-alphabet characters)
      const aName = a?.name ?? '';
      const bName = b?.name ?? '';

      // Function to check if a character is alphabetic
      const isAlpha = (char: string): boolean => /^[A-Za-z]$/.test(char);

      // Get the first character of the product name and check if it's alphabetic
      const firstCharA = aName.trim().charAt(0);
      const firstCharB = bName.trim().charAt(0);

      // If the first character is non-alphabetic, put it at the end
      if (!isAlpha(firstCharA) && isAlpha(firstCharB)) return 1;
      if (isAlpha(firstCharA) && !isAlpha(firstCharB)) return -1;

      // Otherwise, compare the names alphabetically
      return aName.localeCompare(bName);
    });
  }

  handleProductChange(index?: number, item?: any) {
    let selectedProduct = this.products.find(product => product?.id == item);
    const variants                          = selectedProduct?.productVariants || [];
    this.selectedProductsForVariants[index] = selectedProduct;
    this.showProductImage[index]            = !!selectedProduct?.image;
    this.productImageUrls[index]              = selectedProduct?.image || '';
    if (variants.length > 0) {
      this.showProductVariant[index] = variants.length > 0;
      const defaultVariant = variants[0];
      this.onVariantSelect(index, defaultVariant);
    }
    this.handleFlexibleProductPrice(index);
    this.setProductValue();
  }

  handleFlexibleProductPrice(index: number) {
    try {
      this.selectedProducts = this._deliveryForm.controls.deliveryProducts?.value ?? [];
      const item = this.selectedProducts[index];
      const product: Product = this.products.find(p => p.id === item.product.id);
      let quantity = item?.product?.quantity ? Number(item?.product?.quantity) : 1;
      let price = product?.price ? Number(product?.price) : 0;

      const flexiblePriceControl = this._deliveryForm.get('deliveryProducts')
        .get([index])
        .get('product')
        .get('flexiblePrice');

      if (item?.productVariant) {
        let variant = product?.productVariants.find((v) => v.id === item.productVariant);
        price = Number(variant?.variantPrice);
        if (!isNaN(price) && !isNaN(quantity)) {
          flexiblePriceControl.setValue(price); 
        }
      } else {
        if (!isNaN(price) && !isNaN(quantity)) {
          flexiblePriceControl.setValue(price); 
        }
      }
    } catch (error) {
      console.log("Error updating flexible prices:", error);
    }
  }
  

  handleManualPriceUpdate(index: number, value: number) {
    try {
      const selectedProduct = this.selectedProducts[index];
      const product: Product = this.products.find(p => p.id === selectedProduct.product.id);
      let quantity = selectedProduct.product?.quantity ? Number(selectedProduct.product.quantity) : 1;

      if (isNaN(value)) {
        return;
      }

      const flexiblePriceControl = this._deliveryForm.get('deliveryProducts')
        .get([index])
        .get('product')
        .get('flexiblePrice');
      
      flexiblePriceControl?.setValue(value);

      this.setProductValue();
    } catch (error) {
      console.log("Error in handleManualPriceUpdate:", error);
    }
  }


  onVariantSelect(index: number, variant: any) {
    this.selectedVariants[index] = variant;
    const control = this._deliveryForm.get('deliveryProducts') as FormArray;
    const group = control.at(index) as FormGroup;
    group.get('productVariant')?.setValue(variant.id);
    // this.selectedVariants[index] = variant;
    this.handleFlexibleProductPrice(index);
    this.setProductValue();
  }

  handleProductQuantityChange(){
    this.setProductValue();
  }

  setProductValue(){ 
    try {
      const deliveryId: string = this.route.snapshot.paramMap.get('id');
      this.selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;
      /*
      this.TotalSelectedProPrice = this.selectedProducts?.map(item => {
        /*
        const isWithoutCommission = item?.product?.deliveryWithoutCommision === true;
        if (isWithoutCommission) {
          return 0;
        }
        */
       /*
        const product: Product = this.products.find(p => p.id === item.product.id);
        let quantity = item?.product?.quantity ? Number(item?.product?.quantity) : 1;
        let price    = product?.price ? Number(product?.price) : 0;

        const flexiblePriceControl = this._deliveryForm.get('deliveryProducts')
          .get([this.selectedProducts.indexOf(item)])
          .get('product')
          .get('flexiblePrice');

        if (this._deliveryForm.get('isFlexiblePrice').value && flexiblePriceControl?.value != null) {
          price = Number(flexiblePriceControl.value);
        } else {
          if (item?.productVariant) {
            let variant = product?.productVariants.find((v) => v.id === item.productVariant);
            price = Number(variant?.variantPrice);
          }
        }

        if (!isNaN(price) && !isNaN(quantity)) {
          return price * quantity;
        }
      }).reduce((acc, curr) => acc + curr, 0);

      let price = this.TotalSelectedProPrice ? ((Number(this.selectedService?.price) || 0) * (Number(this.TotalSelectedProPrice) || 0)) / 100 : 0;
      if(this.selectedService?.service?.pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL) {
        this._deliveryForm.controls.price?.setValue(Number(price).toFixed(2));
      }
      console.log("PARTNER SALES PRICE NORMAL", price);
      console.log("PRODUCT_VALUE", this.TotalSelectedProPrice);
      this._deliveryForm.controls.productValue?.setValue(this.TotalSelectedProPrice ? this.TotalSelectedProPrice : 0);
      */

      let totalForCommission = 0;
      let totalProductValue = 0;

      this.selectedProducts?.forEach((item, index) => {

        const product: Product = this.products.find(p => p.id === item.product.id);

        let quantity = item?.product?.quantity ? Number(item.product.quantity) : 1;

        let price = product?.price ? Number(product.price) : 0;

        const flexiblePriceControl = this._deliveryForm
          .get('deliveryProducts')
          .get([index])
          .get('product')
          .get('flexiblePrice');

        if (
          this._deliveryForm.get('isFlexiblePrice').value &&
          flexiblePriceControl?.value != null
        ) {
          price = Number(flexiblePriceControl.value);
        } else {
          if (item?.productVariant) {
            const variant = product?.productVariants?.find(
              v => v.id === item.productVariant
            );

            price = Number(variant?.variantPrice || 0);
          }
        }

        const totalPrice = (!isNaN(price) && !isNaN(quantity))
          ? price * quantity
          : 0;

        totalProductValue += totalPrice;

        if (!item?.product?.deliveryWithoutCommision) {
          totalForCommission += totalPrice;
        }

      });

      this.TotalSelectedProPrice = totalForCommission;

      let price = totalForCommission
        ? ((Number(this.selectedService?.price) || 0) * totalForCommission) / 100
        : 0;

      if (
        this.selectedService?.service?.pricingModel ===
        APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL
      ) {
        this._deliveryForm.controls.price?.setValue(
          Number(price).toFixed(2)
        );
      }

      this._deliveryForm.controls.productValue?.setValue(
        totalProductValue || 0
      );

      this.syncShowProductValueVisibility();

      /* For Ware-House service */
      if(this.selectedService?.service?.pricingModel == APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) {
        this.handleWareServiceInvoicePrice();
      }

      /* For Ware-House salary */
      if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_SALARY_MODEL){
        this.handleWareServiceSalaryPrice();
      }
      // Other service types have their own calculations.
    } catch (error) {
      console.log("ERROR", error)
    }
  }

  /*
  setProductValue(){
    if(this.selectedService?.service?.pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL){
      this.selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;
      this.TotalSelectedProPrice = this.selectedProducts?.map(item => {
        const product = this.products.find(p => p.id === item.product.id);
        const quantity = Number(item?.product?.quantity);
        const price = Number(product?.price);
        if (!isNaN(price) && !isNaN(quantity)) {
            return price * quantity;
        } else {
            this.showSnackBar('Can not calculate price and product value for product');
            return false;
            return 0;
        }
      }).reduce((acc, curr) => acc + curr, 0);

      this._deliveryForm.controls.price?.setValue(this.TotalSelectedProPrice ? (this.selectedService?.price * this.TotalSelectedProPrice)/100 : 0);
      this._deliveryForm.controls.productValue?.setValue(this.TotalSelectedProPrice ? this.TotalSelectedProPrice : 0);
    }
  }
  */

  // handleDistanceChange(distance: any){
  //   let price: any = 0;
  //   if(
  //     (this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel == APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) 
  //     || (this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner'))
  //   ) {
  //     console.log("distance",  distance);
  //     console.log("this.selectedPartner?.kmIncluded",  this.selectedPartner?.kmIncluded);
  //     console.log("distance",  distance);
  //     console.log("distance",  distance);
  //     if(distance > this.selectedPartner?.kmIncluded && this.selectedPartner?.kmIncluded){
  //       let extraKm = (distance - this.selectedPartner?.kmIncluded);
  //       price = parseFloat(this.selectedService?.price) + (extraKm * this.selectedService?.extraKmPrice);
  //       console.log("extraKm", extraKm)
  //       console.log("this.selectedService?.price", this.selectedService?.price)
  //       console.log("this.selectedService?.extraKmPrice", this.selectedService?.extraKmPrice)
  //     } else {
  //       price = parseFloat(this.selectedService?.price)
  //     }
  //   }

  //   console.log("PARTNER FIXED PRICE NORMAL", price);
  //   if (!this.isDeliveryAndPartnerCitySame) {
  //     const kmPrice = this.selectedPartner?.extraOutSideCityKmPrice || 0;
  //     const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;
  //     const extraOutsideCityValue = kmPrice * distance;
  //     price = price + extraOutsideCityValue;
  //     console.log("PARTNER EXTRA OUTSIDE CITY FIXED PRICE", price);
  //   }
    
  //   this._deliveryForm.controls.price?.setValue(parseFloat(price)?.toFixed(2));
  //   this._deliveryForm.controls.distance?.setValue(distance.toFixed(2));

  //   /* For Ware-House service */
  //   if(this.selectedService?.service?.pricingModel == APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) {
  //     this.handleWareServiceInvoicePrice();
  //   }

  //   /* For Ware-House salary */
  //   if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_SALARY_MODEL){
  //     this.handleWareServiceSalaryPrice();
  //   }
  // }

  handleDistanceChange(distance: any){
    let price: any = 0;
    if(
      (this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL || this.selectedService?.service?.pricingModel == APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL)
      || (this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner'))
    ) {
      console.log("distance",  distance);
      console.log("this.selectedPartner?.kmIncluded",  this.selectedPartner?.kmIncluded);
      console.log("distance",  distance);
      console.log("distance",  distance);
      if (!this.isDeliveryAndPartnerCitySame) {
        const kmPrice = this.selectedPartner?.extraOutSideCityKmPrice || 0;
        const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;
        const extraOutsideCityValue = kmPrice * distance;
        price = price + extraOutsideCityValue;
        console.log("PARTNER EXTRA OUTSIDE CITY FIXED PRICE", price);
      } else {
        if(distance > this.selectedPartner?.kmIncluded && this.selectedPartner?.kmIncluded){
          let extraKm = (distance - this.selectedPartner?.kmIncluded);
          price = parseFloat(this.selectedService?.price) + (extraKm * this.selectedService?.extraKmPrice);
          console.log("extraKm", extraKm)
          console.log("this.selectedService?.price", this.selectedService?.price)
          console.log("this.selectedService?.extraKmPrice", this.selectedService?.extraKmPrice)
        } else {
          price = parseFloat(this.selectedService?.price)
        }
      }
    }

    console.log("PARTNER FIXED PRICE NORMAL", price);
   
    this._deliveryForm.controls.price?.setValue(parseFloat(price)?.toFixed(2));
    this._deliveryForm.controls.distance?.setValue(distance.toFixed(2));

    /* For Ware-House service */
    if(this.selectedService?.service?.pricingModel == APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) {
      this.handleWareServiceInvoicePrice();
    }

    /* For Ware-House salary */
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_SALARY_MODEL){
      this.handleWareServiceSalaryPrice();
    }
  }

  handleWareServiceInvoicePrice() {

    const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;

    const servicePrice = Number(this.selectedService?.price) || 0;
    const extraKmPrice = Number(this.selectedService?.extraKmPrice) || 0;
    const pricePerItemRate = Number(this.selectedService?.pricePerItem) || 0;

    let transportCost = 0;

    // Base transport cost
    transportCost = servicePrice;

    // Extra KM cost
    if (this.selectedPartner?.kmIncluded && distance > this.selectedPartner.kmIncluded) {
      const extraKm = distance - this.selectedPartner.kmIncluded;
      transportCost += extraKm * extraKmPrice;
    }

    console.log("NORMAL TRANSPORT COST", transportCost);

    // Outside city cost
    if (!this.isDeliveryAndPartnerCitySame) {
      const kmPrice = Number(this.selectedPartner?.extraOutSideCityKmPrice) || 0;
      const extraOutsideCityValue = kmPrice * distance;

      transportCost += extraOutsideCityValue;

      console.log("EXTRA OUTSIDE CITY TRANSPORT COST", transportCost);
    }

    const selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;

    let totalQuantity = 0;
    let totalProducts = 0;

    selectedProducts?.forEach(item => {
      const quantity = Number(item?.product?.quantity) || 0;
      console.log("item quantity", quantity);
      totalQuantity += quantity;
      totalProducts += 1;
    });

    console.log("totalQuantity", totalQuantity);
    console.log("totalProducts", totalProducts);
    console.log("pricePerItemRate", pricePerItemRate);

    const pricePerItem = pricePerItemRate * totalQuantity;
    //const totalQuantityAndProductsPrice = totalQuantity * pricePerItemRate;

    console.log("this.selectedService?.pricePerItem", pricePerItemRate);
    //console.log("totalQuantityAndProductsPrice", totalQuantityAndProductsPrice);
    console.log("pricePerItem", pricePerItem);

    //const finalPrice = servicePrice + pricePerItem + transportCost;
    const finalPrice = pricePerItem + transportCost;

    console.log("finalPrice", finalPrice);

    this._deliveryForm.controls.price?.setValue(Number(finalPrice).toFixed(2));
    this._deliveryForm.controls.distance?.setValue(Number(distance).toFixed(2));
  }

  async handleWareServiceSalaryPrice() {
    try {
      if (this.selectedExpert) {
        this._deliveryForm.controls.valetStartTime.setValue(null);
        this._deliveryForm.controls.valetEndTime.setValue(null);
        this.showValetStartAndEndTime = false;

        let pickUpAddLat: any;
        let pickUpAddLng: any;
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        const salaryPrice = Number(this.selectedExpertService.salary) || 0;
        const extraKmPrice = Number(this.selectedExpertService.minimumKmPrice) || 0;
        const salaryPerItemRate = Number(this.selectedExpertService?.salaryPerItem) || 0;

        let transportCost = 0;

        // Base transport cost
        transportCost = salaryPrice;

        if (this._deliveryForm.controls.pickUpAddress.value) {
          const pickUpAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.pickUpAddress.value);
          pickUpAddLat = pickUpAddressResult[0]?.geometry?.location?.lat() || '';
          pickUpAddLng = pickUpAddressResult[0]?.geometry?.location?.lng() || '';
        }

        if (this._deliveryForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        if (pickUpAddLat && pickUpAddLng && deliveryAddLat && deliveryAddLng) {
          const pickUpAddressLatLng = new google.maps.LatLng(pickUpAddLat, pickUpAddLng);
          const deliveryAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
          const distanceMatrixService = new google.maps.DistanceMatrixService();

          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [pickUpAddressLatLng],
              destinations: [deliveryAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          let valetSalary: number = 0;

          if (this.selectedExpert?.minimumKmIncluded && distanceInKm > this.selectedExpert?.minimumKmIncluded) {
            const extraKm = distanceInKm - this.selectedExpert?.minimumKmIncluded;
            transportCost += extraKm * extraKmPrice;
          }

          console.log("VALET FIXED PRICE SALARY NORMAL", transportCost.toFixed(2));
          if(!this.isDeliveryAndPartnerCitySame) {
            const kmPrice = this.selectedExpert?.extraOutSideCityKmPrice || 0;
            const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;
            const extraOutsideCityValue = kmPrice * distance;
            transportCost += extraOutsideCityValue;
            console.log("VALET EXTRA OUTSIDE CITY FIXED PRICE SALARY", transportCost);
          }

          const selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;

          let totalQuantity = 0;

          selectedProducts?.forEach(item => {
            const quantity = Number(item?.product?.quantity) || 0;
            console.log("item quantity", quantity);
            totalQuantity += quantity;
          });

          console.log("totalQuantity", totalQuantity);

          const salaryPerItem = salaryPerItemRate * totalQuantity;

          console.log("this.selectedService?.salaryPerItem", salaryPerItemRate);
          console.log("salaryPerItem", salaryPerItem);

          const finalPrice = salaryPrice + salaryPerItem + transportCost;

          console.log("finalPrice", finalPrice);

          this._deliveryForm.controls.expertSalary?.setValue(finalPrice.toFixed(2));
          this._deliveryForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);

          if (!this._deliveryForm.controls.payable.value) {
            this.setToZeroIfNotPayable();
          }

          console.log('distanceInKm', distanceInKm);
          console.log('valetSalary', this._deliveryForm.controls.expertSalary?.value);
          console.log('this.selectedExpertService?.service?.serviceType', this.selectedExpertService?.service?.serviceType);

        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickup address and delivery address");
          return;
        }
      }
    } catch (error) {
      console.error('Error calculating distance:', error);
      alert("Can not calculate distance. Try again with valid address, Check both pickup address and delivery address");
    }
  }

  async getPickUpAddress(place: any) {
    if((this.selectedService?.service?.pricingModel === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL) || (this.selectedService?.service?.pricingModel == APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL && this.groups.includes('partner'))){
      try {
        if (!this._deliveryForm) return;
        this._deliveryForm.controls.pickUpAddress.touched = true;
        this._deliveryForm.controls.pickUpAddress.setValue(place.formatted_address || place.name || '');
        let pickUpAddLat: any;
        let pickUpAddLng: any;
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        if (this._deliveryForm.controls.pickUpAddress.value) {
          const pickUpAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.pickUpAddress.value);
          pickUpAddLat = pickUpAddressResult[0]?.geometry?.location?.lat() || '';
          pickUpAddLng = pickUpAddressResult[0]?.geometry?.location?.lng() || '';
          this.pickUpAddressLat = pickUpAddLat;
          this.pickUpAddressLng = pickUpAddLng;
        }

        if (this._deliveryForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        this.isDeliveryAndPartnerCitySame = await this.commanUsesService.checkDeliveryAndPartnerAddressCity((this._deliveryForm.controls.address.value), (place.formatted_address || place.name));
        
        if (pickUpAddLat && pickUpAddLng && deliveryAddLat && deliveryAddLng) {
          const pickUpAddressLatLng = new google.maps.LatLng(pickUpAddLat, pickUpAddLng);
          const deliveryAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
          const distanceMatrixService = new google.maps.DistanceMatrixService();

          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [pickUpAddressLatLng],
              destinations: [deliveryAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          // console.log('distanceInKm', distanceInKm)
          this._deliveryForm.controls.distance.setValue(distanceInKm?.toFixed(2));
          this.handleDistanceChange(distanceInKm);
        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
          return;
        }
      } catch (error) {
        // console.log('Error===>', error)
        alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
        return;
      }
    } else {
      this._deliveryForm.controls.pickUpAddress.setValue(place.formatted_address || place.name || '');
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary'){
      this.calculateFixedPriceValetSalary();
    }
    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL) {
      this.setProductValue();
    }

    if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL) {
      this.managePriceForCorporateService();
    }
  }

  pickUpDirections(event: Event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this._deliveryForm.controls.pickUpAddress.value}`, '_blank');
  }

  handlePickUpFlexbleTime(){
    if(this._deliveryForm.controls.isFlexblePickUpTime.value){
      this.pickUpFTimeError = !this.pickUpFTime;
      this.pickUpTTimeError = !this.pickUpTTime;
    }
    if(this.pickUpFTime && this.pickUpTTime){
      let time = this.pickUpFTime + "-" + this.pickUpTTime;
      this._deliveryForm.controls.pickUpTime?.setValue(time);
    }
  }

  patchPickUpFlexbleTime(){
    let [startTime, endTime] = this.delivery.pickUpTime.split("-");
    this.pickUpFTime = startTime;
    this.pickUpTTime = endTime;
  }

  handleFlexbileDelivery(event: any){
    return false;
  }

  handleBillable(event: any){
    this._deliveryForm.controls.bilable?.setValue(event.target.checked);
    this.checkDeliveryIsBillable();
  }

  checkDeliveryIsBillable(){
    if(!this._deliveryForm.controls.billable.value){    // Delivery is not billable
      this._deliveryForm.controls.price.setValue(0);
      this._deliveryForm.controls.additionalPrice.setValue(0);
    }
    this.disableAdditionalPriceInput = !this._deliveryForm.controls.billable.value;
  }

  handlePayable(event: any){
    this._deliveryForm.controls.bilable?.setValue(event.target.checked);
    this.checkDeliveryIsPayable();
  }

  checkDeliveryIsPayable(){
    if(!this._deliveryForm.controls.payable.value){    // Delivery is not payable
      this.setToZeroIfNotPayable();
    }
    this.disableValetAdditionalPriceInput = !this._deliveryForm.controls.payable.value;
  }

  setToZeroIfNotPayable(){
    this._deliveryForm.controls.expertSalary.setValue(0);
    this._deliveryForm.controls.valetAdditionalPrice.setValue(0);
  }

  handleValetServiceChange(valetServiceId: number){
    this.selectedExpertService = this.selectedExpertServices.find(expertService => expertService?.id == valetServiceId);
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_SALARY_MODEL){
      this.calculateFixedPriceValetSalary();
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL){
      this.calculateHourlyRateValetSalary();
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_SALARY_MODEL){
      this.handleWareServiceSalaryPrice();
    }
  }

  expertServiceAndSalary(){
    if([APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL, APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL].includes(this.selectedService?.service?.pricingModel?.toLowerCase()) || (["corporate"].includes(this.selectedService?.service?.pricingModel?.toLowerCase()) || this.groups.includes('partner'))){
      this.selectedExpertService = this.selectedExpert?.expertServices.find((expertService: any) => {
        let data = expertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_SALARY_MODEL;
        return data;
      })
      this.calculateFixedPriceValetSalary();
    } else if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL) {
      this.selectedExpertService = this.selectedExpert?.expertServices.find((expertService: any) => {
        let data = expertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_SALARY_MODEL;
        return data;
      });
      this.calculateHourlyRateValetSalary();
    } else if(this.selectedService?.service?.pricingModel?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL) {
      this.selectedExpertService = this.selectedExpert?.expertServices.find((expertService: any) => {
        let data = expertService?.service?.serviceType?.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_SALARY_MODEL;
        return data;
      });
      this.handleWareServiceSalaryPrice();
    }
    this._deliveryForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);
  }

  async calculateFixedPriceValetSalary() {
    try {
      if (this.selectedExpert) {
        this._deliveryForm.controls.valetStartTime.setValue(null);
        this._deliveryForm.controls.valetEndTime.setValue(null);
        this.showValetStartAndEndTime = false;

        let pickUpAddLat: any;
        let pickUpAddLng: any;
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        if (this._deliveryForm.controls.pickUpAddress.value) {
          const pickUpAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.pickUpAddress.value);
          pickUpAddLat = pickUpAddressResult[0]?.geometry?.location?.lat() || '';
          pickUpAddLng = pickUpAddressResult[0]?.geometry?.location?.lng() || '';
        }

        if (this._deliveryForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._deliveryForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        if (pickUpAddLat && pickUpAddLng && deliveryAddLat && deliveryAddLng) {
          const pickUpAddressLatLng = new google.maps.LatLng(pickUpAddLat, pickUpAddLng);
          const deliveryAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
          const distanceMatrixService = new google.maps.DistanceMatrixService();

          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [pickUpAddressLatLng],
              destinations: [deliveryAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          let valetSalary: number = 0;

          if (this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary') {
            if (this.selectedExpert?.minimumKmIncluded && distanceInKm > this.selectedExpert?.minimumKmIncluded) {
              const extraKm = distanceInKm - this.selectedExpert?.minimumKmIncluded;
              valetSalary = this.selectedExpertService.salary + (extraKm * Number(this.selectedExpertService.minimumKmPrice));
            } else {
              valetSalary = this.selectedExpertService.salary;
            }
          }

          // console.log("VALET FIXED PRICE SALARY NORMAL", valetSalary.toFixed(2));
          if(!this.isDeliveryAndPartnerCitySame) {
            const kmPrice = this.selectedExpert?.extraOutSideCityKmPrice || 0;
            const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;
            const extraOutsideCityValue = kmPrice * distance;
            valetSalary = extraOutsideCityValue;
            // console.log("VALET EXTRA OUTSIDE CITY FIXED PRICE SALARY", valetSalary);
          }

          this._deliveryForm.controls.expertSalary?.setValue(valetSalary.toFixed(2));
          this._deliveryForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);

          if (!this._deliveryForm.controls.payable.value) {
            this.setToZeroIfNotPayable();
          }

          /*
          console.log('distanceInKm', distanceInKm);
          console.log('valetSalary', this._deliveryForm.controls.expertSalary?.value);
          console.log('this.selectedExpertService?.service?.serviceType', this.selectedExpertService?.service?.serviceType);
          */

        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickup address and delivery address");
          return;
        }
      }
    } catch (error) {
      console.error('Error calculating distance:', error);
      alert("Can not calculate distance. Try again with valid address, Check both pickup address and delivery address");
    } 
  }

  async getLatLngByAddress(address: string){
    const geocoder = new google.maps.Geocoder();
    const results = await new Promise<any>((resolve, reject) => {
      geocoder.geocode({ 'address': address }, (results, status) => {
        if (status === 'OK') {
          resolve(results);
        } else {
          reject(status);
        }
      });
    });
    return results;
  }

  /*
  handleValetStartTimeChange(value: string){
    this._deliveryForm.controls.valetStartTime.setValue(value);
    const startTime = new Date('1970-01-01T' + this._deliveryForm.controls.valetStartTime.value + ':00');
    const endTime = new Date(startTime.getTime() + 3600000);
    const endTimeString = this.formatTime(endTime);
    this._deliveryForm.controls.valetEndTime.setValue(endTimeString);
    this.calculateValetTimeDifference();
  }

  handleValetEndTimeChange(value: string){
    this._deliveryForm.controls.valetEndTime.setValue(value);
    this.calculateValetTimeDifference();
  }

  calculateValetTimeDifference() {
    const startTime = new Date('1970-01-01T' + this._deliveryForm.controls.valetStartTime.value + ':00');
    const endTime = new Date('1970-01-01T' + this._deliveryForm.controls.valetEndTime.value + ':00');
    const timeDiff = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(timeDiff / 3600000);
    if(hours <= 0){
      alert('Minimum one hour is required');
      this._deliveryForm.controls.valetStartTime.setValue(this.previousValetTimeValues.valetStartTime);
      this._deliveryForm.controls.valetEndTime.setValue(this.previousValetTimeValues.valetEndTime);
      return false;
    }
    const minutes = Math.floor((timeDiff % 3600000) / 60000);
    // let totalTime = `${hours}.${minutes}`;
    // this.totalValetTimeDifference = totalTime;
    const totalTime = hours + minutes / 60;
    this.totalValetTimeDifference = totalTime.toFixed(2);
    // console.log('this.totalValetTimeDifference', this.totalValetTimeDifference)
    this.previousValetTimeValues.valetStartTime = this._deliveryForm.controls.valetStartTime.value;
    this.previousValetTimeValues.valetEndTime = this._deliveryForm.controls.valetEndTime.value;
    this.calculateHourlyRateValetSalary();
  }
  */

  handleValetStartTimeChange(value: string) {
    this._deliveryForm.controls.valetStartTime.setValue(value);

    const startTime = this.parseTimeToUTC(value);
    const endTime = new Date(startTime.getTime() + 3600000); // add 1 hour
    const endTimeString = this.formatTimeUTC(endTime);

    this._deliveryForm.controls.valetEndTime.setValue(endTimeString);
    this.calculateValetTimeDifference();
  }

  handleValetEndTimeChange(value: string) {
    this._deliveryForm.controls.valetEndTime.setValue(value);
    this.calculateValetTimeDifference();
  }

  calculateValetTimeDifference() {
    const startTime = this.parseTimeToUTC(this._deliveryForm.controls.valetStartTime.value);
    const endTime = this.parseTimeToUTC(this._deliveryForm.controls.valetEndTime.value);

    const timeDiff = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(timeDiff / 3600000);

    if (hours <= 0) {
      alert('Minimum one hour is required');
      this._deliveryForm.controls.valetStartTime.setValue(this.previousValetTimeValues.valetStartTime);
      this._deliveryForm.controls.valetEndTime.setValue(this.previousValetTimeValues.valetEndTime);
      return false;
    }

    const minutes = Math.floor((timeDiff % 3600000) / 60000);
    const totalTime = hours + minutes / 60;

    this.totalValetTimeDifference = totalTime.toFixed(2);
    // console.log("this.totalValetTimeDifference", this.totalValetTimeDifference);

    this.previousValetTimeValues.valetStartTime = this._deliveryForm.controls.valetStartTime.value;
    this.previousValetTimeValues.valetEndTime = this._deliveryForm.controls.valetEndTime.value;

    this.calculateHourlyRateValetSalary();
  }

  /**
   * Converts a time string like "14:30" to a Date object in UTC, anchored to a known date.
   */
  parseTimeToUTC(timeStr: string): Date {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return new Date(Date.UTC(1970, 0, 1, hours, minutes, 0));
  }

  /**
   * Converts a UTC Date object to a time string in "HH:mm" format.
   */
  formatTimeUTC(date: Date): string {
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }


  calculateHourlyRateValetSalary(){
    if(this.selectedExpert){
      this.showValetStartAndEndTime = true;
      this._deliveryForm.controls.valetStartTime.setValue(this.previousValetTimeValues.valetStartTime);
      this._deliveryForm.controls.valetEndTime.setValue(this.previousValetTimeValues.valetEndTime);
      let valetSalary = (this.totalValetTimeDifference * this.selectedExpertService?.salary);

      // console.log("VALET HOURLY SALARY NORMAL", valetSalary);
      // console.log("this._deliveryForm.controls?.distance?.value", this._deliveryForm.controls?.distance?.value);
      /*
      if(!this.isDeliveryAndPartnerCitySame) {
        const kmPrice = this.selectedExpert?.extraOutSideCityKmPrice || 0;
        const distance = Number(this._deliveryForm.controls?.distance?.value) || 0;
        const extraOutsideCityValue = kmPrice * distance;
        valetSalary = extraOutsideCityValue;
        // console.log("VALET EXTRA OUTSIDE CITY HOURLY SALARY", valetSalary?.toFixed(2));
      }
      */

      this._deliveryForm.controls.expertSalary.setValue(valetSalary?.toFixed(2));
      this._deliveryForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);
      if(!this._deliveryForm.controls.payable.value){
        this.setToZeroIfNotPayable();
      }
      /*
      console.log('valetSalary', this._deliveryForm.controls.expertSalary?.value)
      console.log('this.selectedExpertService?.service?.serviceType', this.selectedExpertService?.service?.serviceType);
      */
    }
  }

  getErrorMessages(): string[] {
    const errorMessages: string[] = [];

    Object.keys(this._deliveryForm.controls).forEach(key => {
      const controlErrors = this._deliveryForm.get(key)?.errors;
      if (controlErrors) {
        const fieldValidationMessages = Delivery.validationMessages[key];
        if (fieldValidationMessages) {
          Object.keys(controlErrors).forEach(errorKey => {
            const messageObj = fieldValidationMessages.find((msg) => msg.type === errorKey);
            if (messageObj) {
              if (key === 'address' && !errorMessages.includes('address')) {
                errorMessages.push('address');
              } else if (key !== 'address') {
                errorMessages.push(key);
              }
            }
          });
        }
      }
    });

    const customerIdErrors = this._deliveryForm.get('customer.id')?.errors;
    if (customerIdErrors) {
      errorMessages.push('customer');
    }

    const deliveryProductsArray = <FormArray>this._deliveryForm.get('deliveryProducts');
    deliveryProductsArray.controls.forEach((productGroup, index) => {
      const productControl: any = productGroup.get('product');
      const quantityControl = productGroup.get('quantity');

      if (productControl) {
        productControl.updateValueAndValidity();
      }

      if (quantityControl) {
        quantityControl.updateValueAndValidity();
      }
      const productErrors = productControl.controls.id.errors;
      const quantityErrors = productControl.controls.quantity.errors;

      if (productErrors) {
        errorMessages.push('product');
      }

      if (quantityErrors) {
        errorMessages.push('quantity');
      }
    });

    return errorMessages;
  }

  translateErrorMessage(error: string): string {
    const errorMessages: { [key: string]: string } = {
      address: 'PER MODIFICARE, VALIDARE INDIRIZZO',
      name: 'NOME',
      surname: 'COGNOME',
      intercom: 'CITOFONO',
      deliveryDate: 'DATA',
      pickUpTime: 'ORA RITIRO',
      service: 'SERVIZIO',
      product: 'PRODOTTO',
      receiverPhone: 'VALIDARE DESTINATARIO TELEFONO',
      senderPhone: 'VALIDARE MITTENTE TELEFONO',
      smsPhoneNo: 'VALIDARE SMS TELEFONICI',
      customer: 'CUSTOMER',
      payAtDeliveryAmount: 'PAGAMENTO ALLA CONSEGNA PREZZO'
    };
    return errorMessages[error] || '';
  }

  async removeValetActivities(delivery: Delivery){
    try {
      let filtered = {};
      filtered['Delivery.id'] = Number(delivery.id);
      await this.adminValetActivityService.deleteAssignedActivities(filtered);
    } catch (error) {
      // console.log("ERROR: ", error);
    }
  }

  isOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const products of this._deliveryForm.value.deliveryProducts) {
      if (products.product.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId; // assuming your item has a 'disabled' property
  }

  handleExistingCustomer(event: any){
    this.updateValidator(event.target.checked);
  }

  /*
  updateValidator(status: boolean){
    if (status) {
      this._deliveryForm.get('customer.id').setValidators(Validators.required);
      this._deliveryForm.get('surname').clearValidators();
      this._deliveryForm.get('name').clearValidators();
      this._deliveryForm.get('intercom').clearValidators();
      this.newCustomer = false;
    } else {
      this._deliveryForm.get('customer.id').clearValidators();
      this._deliveryForm.get('surname').setValidators(Validators.required);
      this._deliveryForm.get('name').setValidators(Validators.required);
      this._deliveryForm.get('intercom').setValidators(Validators.required);
    }

    this._deliveryForm.get('customer.id').updateValueAndValidity();
    this._deliveryForm.get('surname').updateValueAndValidity();
    this._deliveryForm.get('name').updateValueAndValidity();
    this._deliveryForm.get('intercom').updateValueAndValidity();
  }

  handleCustomerChange(customerId: any) {
    let customer: Customer = this.customers.find(c => c.id == customerId);
    if(customer){
      this._deliveryForm.controls.address.setValue(customer.address);
    } else {
      this._deliveryForm.controls.address.setValue('');
    }
  }
  */

  updateValidator(status: boolean){
    if (status) {
      this._deliveryForm.get('customer.id').setValidators(Validators.required);
      this.newCustomer = false;
    } else {
      this._deliveryForm.get('customer.id').clearValidators();
    }

    this._deliveryForm.get('customer.id').updateValueAndValidity();
  }

  handleCustomerChange(customerId: any) {
    let customer: Customer = this.customers.find(c => c.id == customerId);
    if(customer){
      this._deliveryForm.controls.senderSurname.setValue(customer?.user?.surname || '');
      this._deliveryForm.controls.senderName.setValue(customer?.user?.name || '');
      this._deliveryForm.controls.senderPhone.setValue(customer?.phone || '');
    } else {
      this._deliveryForm.controls.senderSurname.setValue('');
      this._deliveryForm.controls.senderName.setValue('');
      this._deliveryForm.controls.senderPhone.setValue('');
    }
  }

  /*
  setDeliveryDateRestriction(){
    if(this.groups.includes('partner')) {
      this._deliveryForm.get('deliveryDate')?.setValidators(onlyCurrentMonthIfPartner(this.groups.includes('partner')));
      this._deliveryForm.get('deliveryDate')?.updateValueAndValidity();
    }
  }
  */

  setDeliveryDateRestriction() {
    const control = this._deliveryForm.get('deliveryDate');
    if (!control) return;

    if (this.groups.includes('partner')) {
      control.setValidators([
        Validators.required, 
        onlyCurrentMonthIfPartner(true)
      ]);
    } else {
      control.setValidators([
        Validators.required
      ]);
    }

    control.updateValueAndValidity();
  }


  handleFlexiblePayment(event: any) { }

  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  async onExpertIdentityCheckChange(id: number, event: any) {
    event.preventDefault();
    const nextState = !this.expertIdentityCheck;
    const confirmAction = confirm(
      'Expert check will be disabled for this delivery. Do you want to proceed?'
    );

    if (!confirmAction) {
      return;
    }

    let message = ``;

    try {
      this.spinnerService.show();
      const result = await this.deliveryService.manageValetCheck(id, event.target.checked);
      if (result.id) {
        message = `Expert indentity setting has been change for this delivery`;
      } else {
        message = 'Something went wrong';
      }
    } catch (error) {
      message = error?.error?.message || error?.message || 'Something went wrong';
    } finally {
      await this.initialize();
      this.spinnerService.hide();
      this.commanUsesService.showSnackBar(message);
    }
  }

  async onCustomerVerificationChange(id: number, event: any) {
    event.preventDefault();
    const nextState = !this.expertIdentityCheck;
    const confirmAction = confirm('Customer OTP check will be disabled for this delivery. Do you want to proceed?');
    
    let message = ``;
    if (!confirmAction) {
      return;
    }

    try {
      this.spinnerService.show();
      const result = await this.deliveryService.manageCustomerCheck(id, event.target.checked);
      if (result.id) {
        message = `Customer OTP setting has been changed`;
      } else {
        message = 'Something went wrong';
      }
    } catch (error) {
      message = error?.error?.message || error?.message || 'Something went wrong';
    } finally {
      await this.initialize();
      this.spinnerService.hide();
      this.commanUsesService.showSnackBar(message);
    }
  }

  onValetIdentityChange(isChecked: boolean) {
    this.valetIdentity = isChecked;
  }

  onDeliveryCheckChange() {
    if (this.deliveryCheck.deliveryCodeRequired) {
      this.deliveryCheck.deliveryCode = this.generateRandomCode();
    } else {
      this.deliveryCheck.deliveryCode = null;
    }
  }

  generateRandomCode(): string {
    const randomNumber = Math.floor(Math.random() * 900000) + 100000;
    return randomNumber.toString();
  }
  
  handleModalBox() {
    this.showAddressModal = !this.showAddressModal;
  }

  async confirmCustomPickUpAddress() {
    if (this.selectedPartner.isMultiplePickUpAddress && this.selectedPartner.pickupAddresses.length) {
      if (this.selectedPickupAddress) {
        this.isConfirming = true;
        try {
          this._deliveryForm.get('pickUpAddress')?.setValue(this.selectedPickupAddress);
          const geoCodedAddress = await this.mapHelperService.geoCodeAddress(this.selectedPickupAddress);
          if (!geoCodedAddress || geoCodedAddress.length === 0) {
            this.commanUsesService.showSnackBar(`Nessun indirizzo trovato su Google`);
          }

          await this.getPickUpAddress(geoCodedAddress[0]);
          this.handleModalBox();
        } catch (error: any) {
          console.error('Error during address confirmation:', error);
          this.commanUsesService.showSnackBar(`Impossibile confermare l'indirizzo di ritiro. Per favore riprova più tardi.`);
        } finally {
          this.isConfirming = false;
        }
      } else {
        this.commanUsesService.showSnackBar(`Seleziona un indirizzo di ritiro prima di confermare.`);
      }
    } else {
      this.commanUsesService.showSnackBar(`Non ci sono indirizzi di ritiro disponibili per questo partner.`);
    }
  }

  managePriceForCorporateService() {
    /*
    let isCorporateService: boolean = false;
    const partnerService = this.selectedService;
    isCorporateService = this.deliveryId ? this.delivery?.serviceType?.toLowerCase() === 'corporate' : partnerService?.service?.pricingModel?.toLowerCase() === 'corporate';

    this.selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;
    this.selectedProducts?.map((item,  index) => {
      const product: Product = this.products.find(p => p.id === item.product.id);

      this.isProductPublicPrice[index] = isCorporateService;
      this.productPublicPrice[index] = product?.shopifyPrice;

      if (item?.productVariant) {
        let variant = product?.productVariants.find((v) => v.id === item.productVariant);
        this.productPublicPrice[index] = variant?.variantShopifyPrice;
      }
    });
    */

    let isCorporateService: boolean = false;
    const partnerService = this.selectedService;
    isCorporateService = this.deliveryId ? this.delivery?.serviceType?.toLowerCase() === 'corporate' : partnerService?.service?.pricingModel?.toLowerCase() === 'corporate';

    this.selectedProducts = this._deliveryForm.controls.deliveryProducts?.value;
    this.selectedProducts?.map((item,  index) => {
      const product: Product = this.products.find(p => p.id === item.product.id);

      this.isProductPublicPrice[index] = isCorporateService;
      this.productPublicPrice[index] = product?.shopifyPrice;

      if (item?.productVariant) {
        let variant = product?.productVariants.find((v) => v.id === item.productVariant);
        this.productPublicPrice[index] = variant?.variantShopifyPrice;
      }
    });

    this.TotalSelectedProPrice = this.selectedProducts?.map(item => {
      const product: Product = this.products.find(p => p.id === item.product.id);
      let quantity = item?.product?.quantity ? Number(item?.product?.quantity) : 1;
      let price    = product?.shopifyPrice ? Number(product?.shopifyPrice) : 0;

      const flexiblePriceControl = this._deliveryForm.get('deliveryProducts')
        .get([this.selectedProducts.indexOf(item)])
        .get('product')
        .get('flexiblePrice');

      if (this._deliveryForm.get('isFlexiblePrice').value && flexiblePriceControl?.value != null) {
        price = Number(flexiblePriceControl.value);
      } else {
        if (item?.productVariant) {
          let variant = product?.productVariants.find((v) => v.id === item.productVariant);
          price = Number(variant?.variantShopifyPrice);
        }
      }

      if (!isNaN(price) && !isNaN(quantity)) {
        return price * quantity;
      }

    }).reduce((acc, curr) => acc + curr, 0);

    const distance = Number(this._deliveryForm.controls.distance.value) || 0;
    console.log("distance", distance)
    console.log("this.selectedPartner?.kmIncluded", this.selectedPartner?.kmIncluded)
    console.log("distance > this.selectedPartner?.kmIncluded", distance > this.selectedPartner?.kmIncluded)
    let extraKmPrice: number = 0;

    if (!this.isDeliveryAndPartnerCitySame) {
      const kmPrice = Number(this.selectedPartner?.extraOutSideCityKmPrice) || 0;
      extraKmPrice = kmPrice * distance;
      console.log("CORPORATE/SALES OUTSIDE CITY (extraOutSideCityKmPrice * distance)", extraKmPrice);
    } else if (distance && this.selectedPartner?.kmIncluded && distance > this.selectedPartner?.kmIncluded) {
      const extraKm = distance - this.selectedPartner.kmIncluded;
      const basePrice = Number(this.selectedService?.price) || 0;
      const rate = Number(this.selectedService?.extraKmPrice) || 0;
      extraKmPrice = basePrice + extraKm * rate;
      console.log("extraKm", extraKm)
      console.log("this.selectedService?.price", this.selectedService?.price)
      console.log("this.selectedService?.extraKmPrice", this.selectedService?.extraKmPrice)
    }

    const partnerAddon = this.isDeliveryAndPartnerCitySame
      ? Number(partnerService?.price) || 0
      : 0;
    let price = this.TotalSelectedProPrice + extraKmPrice + partnerAddon || 0;
    this._deliveryForm.controls.price?.setValue(Number(price).toFixed(2));
    this._deliveryForm.controls.productValue?.setValue(this.TotalSelectedProPrice ? this.TotalSelectedProPrice : 0);
    this.syncShowProductValueVisibility();

  }

  private setHideCustomerInfoForDelivery(serviceId?: any): void {
    this.showCustomerInformation = !this.shouldHideCustomerInfoForDelivery(serviceId);
  }

  private shouldHideCustomerInfoForDelivery(serviceId?: any): boolean {

    if (!serviceId) {
      return false;
    }

    if(this.groups.includes('partner')) {
      const selectedPartnerService = this.selectedPartnerServices?.find(
        (item) => Number(item?.service?.id) === Number(serviceId)
      );
  
      return selectedPartnerService?.service?.hideCustomerInformation;
    }
  }

}
